/**
 * Das Nivaro-Logo mit Schriftzug, wie auf nivaro.tech.
 *
 * Der Schriftzug ist dunkel. Im dunklen Modus steht das Logo deshalb auf einer
 * hellen Fläche (`.brand-logo` in index.css), sonst verschwände er.
 */
export function NivaroLogo({ className = "" }: { className?: string }) {
  return <img src="/nivaro-logo.png" alt="Nivaro" className={`brand-logo w-auto ${className}`} />;
}
